var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"background"}),_c('v-main',[(_vm.loaded)?_c('spoiled-log'):_c('spoiled-portal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }